import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Input } from "reactstrap";
import { accountInitialize } from "store/accountActions";

const langToSegment = (code) => (code || "").split("-")[0].toLowerCase();

const replaceLanguageInPath = (pathname, newSeg) => {
  const parts = pathname.split("/");

  if (parts.length > 1) {
    parts[1] = newSeg;
  }

  return parts.join("/");
};

const LanguageSelect = ({ fullWidth = false, onLanguageChanged }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const account = useSelector((state) => state.account);
  const { languages } = useSelector((state) => state.staticData);

  const availableLanguages = (languages || []).filter(
    (language) => language.isUsedFromPublishingDocuments
  );

  const changeLanguageHandler = (code) => {
    const language = availableLanguages.find((lang) => lang.code === code);

    if (!language) return;

    if (account?.language?.code !== language.code) {
      dispatch(
        accountInitialize({
          ...account,
          language,
        })
      );

      const newSeg = langToSegment(language.code);
      const newPath = replaceLanguageInPath(location.pathname, newSeg);

      history.push(`${newPath}${location.search || ""}${location.hash || ""}`);
    }

    onLanguageChanged?.();
  };

  return (
    <Input
      id="ddlLanguageList"
      type="select"
      value={account?.language?.code || ""}
      onChange={(e) => changeLanguageHandler(e.target.value)}
      style={{ width: fullWidth ? "100%" : "80px" }}
    >
      {availableLanguages.map((language) => (
        <option key={language.code} value={language.code}>
          {langToSegment(language.code).toUpperCase()}
        </option>
      ))}
    </Input>
  );
};

export default LanguageSelect;
